import { QueryClient, defaultShouldDehydrateQuery } from '@tanstack/react-query'

import { isServer } from '@district-core/utils/environment/isServer.ts'

let browserQueryClient: QueryClient | undefined = undefined

export function getQueryClient() {
  if (isServer) {
    return makeQueryClient()
  }
  // Reuse the browser QueryClient because React can suspend during initial render. A Suspense boundary below
  // QueryClient creation can make the shared client unnecessary.
  return (browserQueryClient ??= makeQueryClient())
}

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
        experimental_prefetchInRender: true,
      },
      dehydrate: {
        // Dehydrate pending queries.
        shouldDehydrateQuery: (query) => defaultShouldDehydrateQuery(query) || query.state.status === 'pending',
        shouldRedactErrors() {
          // Do not catch Next.js server errors. Next.js uses them to detect dynamic pages and redacts them with better
          // digests.
          return false
        },
      },
    },
  })
}
